import type {ReccoRatingDTO} from '@/ts/types/dto/recco/rating.dto';
import type {ReccoIdDTO} from '@/ts/types/dto/recco/recco-id.dto';

/** List of personalized content recommendations returned by the Recco engine */
export type ReccoRecommendationResponse = ReccoRecommendationDTO[];

/** Base content recommendation with identity, type, rating, bookmark state, and display metadata */
export interface ReccoRecommendationDTO {
  id: ReccoIdDTO;
  type: ReccoRecommendationTypeDTO;
  rating: ReccoRatingDTO;
  status: string;
  bookmarked: boolean;
  headline: string;
  description?: string | null;
  imageAlt: string | null;
  dynamicImageResizingUrl: string | null;
  topic?: string | null;
  
}

/** Content types available as Recco recommendations */
export enum ReccoRecommendationTypeDTO {
  Article = 'articles',
  Questionnaire = 'questionnaires',
  Audio = 'audios',
  Video = 'videos',
  TrackingActivity = 'tracking_activities',
}
